import { toastsIntlIds } from './toasts.ids';

export const toastsLangEsMx = {
  [toastsIntlIds.onLoadingToast.title]: 'Acción en progreso',
  [toastsIntlIds.onLoadingToast.description]:
    'Espere unos momentos mientras completamos esta acción',
};
